<div class="flex flex-col">
  <div class="flex flex-col-reverse w-full relative">
    <input
      sag-ui-input
      type="text"
      class="pr-8"
      [id]="id"
      [disabled]="disabled"
      [required]="invalid || (required && touched)"
      [attr.pattern]="invalid ? 'SAG_INVALID_STATE' : null"
      [placeholder]="placeholder"
      [value]="displayValue"
      (input)="handleInput($event)"
      (change)="handleChange()"
      (focus)="onFocus()"
      (blur)="onBlur()"
      #input
    />
    <label sag-ui-input-label [htmlFor]="id">
      <span *ngIf="required">*</span>
      {{ label }}
      <span
        *ngIf="hint"
        class="text-[#999999] dark:text-[#666666] icon-circle-information pl-2"
        sag-ui-tooltip
        [tooltip]="hint"
      ></span>
    </label>
    <span
      class="absolute right-5 bottom-[0.8rem] text-black dark:text-white icon-user"
      [class.opacity-50]="disabled"
    ></span>
    <div [class]="popoverClasses" [class.hidden]="!isOpen">
      @for (option of options; track option.gid) {
        <sag-ui-scd-picker-option
          [value]="option"
          [selected]="option === selected"
          (click)="handleSelect(option)"
        >
          {{ option.firstName }} {{ option.lastName }} ({{ option.gid }})
        </sag-ui-scd-picker-option>
      }
    </div>
  </div>
</div>
